"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAlert = void 0;
var colors_1 = require("../colors");
exports.MuiAlert = {
    defaultProps: {
        icon: false,
    },
    styleOverrides: {
        root: {
            alignItems: 'center',
            fontSize: 14,
            padding: '2px 16px',
            lineHeight: '20px',
            '.MuiIconButton-sizeSmall': {
                fontSize: 14,
                '&:active': {
                    borderRadius: '3px',
                },
            },
            '.MuiButton-text': {
                fontWeight: '800',
                lineHeight: '14px',
                minHeight: '24px',
                minWidth: 'auto',
                whiteSpace: 'nowrap',
            },
        },
        action: {
            padding: 0,
            alignItems: 'center',
        },
        standardError: {
            color: colors_1.tannerSemantic.error.color,
            backgroundColor: colors_1.tannerSemantic.error.background,
            '.MuiIconButton-sizeSmall, .MuiButton-text': {
                color: colors_1.tannerSemantic.error.color,
                '&:hover': {
                    color: colors_1.tannerSemantic.error['700'],
                    backgroundColor: colors_1.tannerSemantic.error['100'],
                },
            },
        },
        standardInfo: {
            color: colors_1.tannerSemantic.info.color,
            backgroundColor: colors_1.tannerSemantic.info.background,
            '.MuiIconButton-sizeSmall, .MuiButton-text': {
                color: colors_1.tannerSemantic.info.color,
                '&:hover': {
                    color: colors_1.tannerSemantic.info['600'],
                    backgroundColor: colors_1.tannerSemantic.info['100'],
                },
            },
        },
        standardSuccess: {
            color: colors_1.tannerSemantic.success.color,
            backgroundColor: colors_1.tannerSemantic.success.background,
            '.MuiIconButton-sizeSmall, .MuiButton-text': {
                color: colors_1.tannerSemantic.success['500'],
                '&:hover': {
                    color: colors_1.tannerSemantic.success['600'],
                    backgroundColor: colors_1.tannerSemantic.success['100'],
                },
            },
        },
        standardWarning: {
            color: colors_1.tannerSemantic.warning.color,
            backgroundColor: colors_1.tannerSemantic.warning.background,
            '.MuiIconButton-sizeSmall, .MuiButton-text': {
                color: colors_1.tannerSemantic.warning.color,
                '&:hover': {
                    color: colors_1.tannerSemantic.warning['600'],
                    backgroundColor: colors_1.tannerSemantic.warning['100'],
                },
            },
        },
    },
};
//# sourceMappingURL=MuiAlert.js.map